export default __webpack_public_path__ + "static/media/PolycomExportRestrictions.ee9cb98b.pdf";